angular.module('note')
    .component('noteList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/note/list.html',
        controller: function ($scope, $state, $stateParams, NoteService) {
            this.NoteService = NoteService;
            this.reset = () => this.filters = {}
            $scope.$on('note.updated', () => $state.reload());
            $scope.$on('note.deleted', () => $state.reload());
        }
    })
